export const GA4_ID = 'G-ZHB7YCRLNN';
export const GOOGLE_ADS_ID = 'AW-18483366568';
export const HOTJAR_ID = 6381077;

// TODO: replace REPLACE_WITH_LABEL with the conversion label shown in Google Ads
// (Goals > Conversions > the sign-up action > Tag setup > Use Google Tag Manager/gtag).
export const GADS_SIGNUP_SEND_TO = 'AW-18483366568/REPLACE_WITH_LABEL';
